'';
import { memo } from 'react';
import { Collapse, Stack } from '@chakra-ui/react';

import TooltipText from 'shared/TooltipText';

const ErrorText = ({ error, hint, fieldName }) => (
  <Collapse in={error} animateOpacity unmountOnExit>
    <Stack w="full" gap="0" pos="absolute" bottom="-1px">
      <Stack w="full" maxH={{ laptop: '24px', mobile: '18px' }} pos="absolute" top="0" left="0">
        <TooltipText
          isFullWidth
          title={hint}
          titleProps={{
            as: 'p',
            id: `${fieldName}_errorText`,
            pl: '15px',
            color: error && 'alert.active',
            textStyle: 'tag',
            fontWeight: '400',
            transition: 'all .2s',
            transform: error ? 'translateX(0px)' : 'translateX(10px)',
            noOfLines: 1,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            opacity: error ? 1 : 0,
            zIndex: '0',
          }}
          tooltipProps={{
            hasArrow: false,
            bgColor: 'culturalCode.bg',
            placement: 'bottom-start',
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, -16],
                },
              },
            ],
          }}
        />
      </Stack>
    </Stack>
  </Collapse>
);

export default memo(ErrorText);
